import CopyButton from './CopyButton';

interface FormattedTextCodeBlockProps {
  language: string;
  content: string;
}

const FormattedTextCodeBlock: React.FC<FormattedTextCodeBlockProps> = ({
  language,
  content,
}) => {
  return (
    <div className="relative overflow-hidden rounded-md border border-gray-200 dark:border-gray-700 my-4">
      <div className="flex items-center justify-between px-4 py-2 bg-gray-800 text-gray-200">
        <span className="text-sm font-mono">{language}</span>
        <CopyButton content={content} />
      </div>
      <pre className="mt-0 px-4 py-3 bg-gray-900 overflow-x-auto text-gray-200">
        <code>{content}</code>
      </pre>
    </div>
  );
};

export default FormattedTextCodeBlock;
